"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ISDATE = void 0;
const tab_1 = require("../../../tab");
exports.ISDATE = {
    description: 'Validate if given value is a date. Returns false if not a date',
    arg_names: ['value_to_validate'],
    args_def: [
        {
            types: ['date'],
            required: true,
        },
    ],
    args_description: ['value to check if it is date'],
    return_type: tab_1.ColumnType.BOOLEAN,
};
